import React from "react";
import QueueAnim from "rc-queue-anim";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { push, replace } from 'connected-react-router';
import {
  CONFIRM_EMAIL_TYPE_LOGIN_LINK,
  LOGIN_LINK_CODE_PAGE_PATH
} from "constants/Paths";
import {
  LOGIN_LINK_STATUS_EXPIRED,
  loginLinkStatus,
  readBindingSecret,
  readFreshPending
} from "services/loginLinkService";
import { isCustomer } from "utils/helpers";

class ConfirmEmail extends React.Component {
  constructor() {
    super();

    this._isMounted = false;
    this.state = {
      canEnterCode: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.checkAuth();
    this.checkLinkSent();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  checkLinkSent() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const pending = readFreshPending();
    const bindingSecret = readBindingSecret();

    if (
      searchParams.get("type") !== CONFIRM_EMAIL_TYPE_LOGIN_LINK ||
      !pending ||
      !bindingSecret
    ) {
      return;
    }

    this.props
      .dispatch(
        loginLinkStatus({ email: pending.email, binding_secret: bindingSecret })
      )
      .then(
        data => {
          if (this._isMounted && data && data.status !== LOGIN_LINK_STATUS_EXPIRED) {
            this.setState({ canEnterCode: true });
          }
        },
        () => {}
      );
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    this.checkAuth(nextProps);
  }

  checkAuth(props) {
    const { isAuthenticated, user } = props || this.props;
    if (isAuthenticated) {
      this.props.dispatch(
        push(user && isCustomer(user) ? "/app/dashboard" : "/login")
      );
    }
  }

  handleEnterCode = () => {
    this.props.dispatch(replace(LOGIN_LINK_CODE_PAGE_PATH));
  };

  render() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const email = searchParams.get("email") || "your email";

    if (searchParams.get("type") === CONFIRM_EMAIL_TYPE_LOGIN_LINK) {
      return (
        <div className="page-auth page-confirm-email page-check-email">
          <div className="main-body">
            <QueueAnim type="bottom" className="ui-animate">
              <div key="1">
                <div className="body-inner">
                  <div className="card bg-color-white">
                    <div className="card-content">
                      <h2 className="text-center">Check Your Email</h2>
                      <p className="text-center text-small no-margin">
                        If the email address exists, a sign-in link will be sent to <strong>{email}</strong>.
                        <br/> Please check for an email from us and click on the
                        included link to sign in directly.
                      </p>
                      {this.state.canEnterCode && (
                        <div className="login-screen check-email-actions">
                          <button
                            type="button"
                            className="login-btn login-btn-outline"
                            onClick={this.handleEnterCode}
                          >
                            <span className="login-btn-label">
                              <span className="material-icons">dialpad</span>
                              Enter code
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="additional-info">
                    <span>
                      Return to <Link to="/login">Login</Link>
                    </span>
                  </div>
                </div>
              </div>
            </QueueAnim>
          </div>
        </div>
      );
    }

    return (
      <div className="page-auth page-confirm-email">
        <div className="main-body">
          <QueueAnim type="bottom" className="ui-animate">
            <div key="1">
              <div className="body-inner">
                <div className="card bg-color-white">
                  <div className="card-content">
                    <div className="logo text-center">
                      <a>Confirm Email</a>
                    </div>

                    <div>
                      <p className="confirm-mail-icon">
                        <span className="material-icons">mail_outline</span>
                      </p>
                      <p className="text-center text-small no-margin">
                        If the email address exists, an email will be sent to <strong>{email}</strong>.
                       <br/> Please check for an email from us and click on the
                        included link to reset your password.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="additional-info">
                  <span>
                    Return to <Link to="/login">Login</Link>
                  </span>
                </div>
              </div>
            </div>
          </QueueAnim>
        </div>
      </div>
    );
  }
}


export default ConfirmEmail;
